import { observer } from "mobx-react";
import {
  useEstimateEditorSettings,
  useEstimateEditorStore,
  useEstimateStructure,
  useEstimateTableSettings,
  ValueCell
} from "@tools";
import { useMemo } from "react";

export const TaskEstimatePlaceholdersCell = observer(({
  cutLastWorkTypes
}) => {
  const { displayTwoValues } = useEstimateStructure();
  const { allowEdition } = useEstimateEditorSettings();
  const { visibilityMode } = useEstimateEditorStore();
  const {
    visibleWorkTypes,
    totalEstimateCells,
    showCombinedHours,
    materialsSection,
    workTypeColumnsMaxState,
  } = useEstimateTableSettings();
  
  const workTypes = useMemo(() => (
    cutLastWorkTypes
      ? visibleWorkTypes.slice(0, -cutLastWorkTypes)
      : visibleWorkTypes
  ), [ cutLastWorkTypes, visibleWorkTypes ])
  
  return <>
    {
      !showCombinedHours && totalEstimateCells > 0 &&
      workTypes.map((workType, index) => (
        <ValueCell
          key={`placeholder${index}`}
          size={workTypeColumnsMaxState[workType.id] ? "medium" : "small"}
          extendPadding={allowEdition || visibilityMode}
        />
      ))
    }
    {
      showCombinedHours && !materialsSection && totalEstimateCells > 0 &&
      <ValueCell size={displayTwoValues ? "large" : "medium"} />
    }
  </>
});